import { Injectable } from '@angular/core';
import { EventDictionary } from '@classes/EventDictionary.class';
import { CruiseItinerarySegmentDTO } from '@interfaces/KT/CruiseItinerarySegment.interface';
import { OTOItinerary } from '@interfaces/OTO/OTOItinerary.interface';
import { fixArray } from '@utils/Array/fixArray.utils';

@Injectable({
  providedIn: 'root',
})
export class OtoItineraryService {
  public readonly ARRIVAL = 0;
  public readonly DEPARTURE = 1;

  /**
   * Contains events indexed by cruise day (ordinal)
   */
  private eventDictionary = new EventDictionary();

  public getSteps(listStep: CruiseItinerarySegmentDTO[], departureDate, harbourPhotos, cruiseDuration) {
    const stepArray = fixArray(listStep);

    //remove useless steps
    const filteredSteps = stepArray.filter((e) => !e.IsNavigationDay);

    //sort steps
    const steps = filteredSteps.sort((a, b) => {
      return Number(a.Day) - Number(b.Day);
    });

    //build events dictionary
    this.eventDictionary.dictionary = {};
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      this.eventDictionary.addEvent(step.Day, this.DEPARTURE, step.DepartureTime, step.Port);
    }

    const duration = cruiseDuration;

    const itin_rows = [];
    for (let day = 0; day <= duration; day++) {
      const events = this.eventDictionary.getEvents(day + 1);

      if (events.length == 0) {
        //navigation
        const navRow = this.buildRow(null, null, null, departureDate, day, null);
        itin_rows.push(navRow);
      } else {
        //number of rows we have to insert for the current day
        const numRows = Math.ceil(events.length / 2);

        let startingEvent = 0;
        for (let r = 0; r < numRows; r++) {
          let harbour = null;
          let arrivalTime = null;
          let departureTime = null;
          let rowCompleted = false;
          let images = null;

          for (let e = startingEvent; e < events.length && !rowCompleted; e++, startingEvent++) {
            const event = events[e];
            if (event.type == this.ARRIVAL) {
              arrivalTime = event.hour;
              harbour = event.harbour;
            }

            if (event.type == this.DEPARTURE) {
              departureTime = event.hour;
              harbour = harbour || event.harbour;

              //we have to add another row after a departure
              rowCompleted = true;
            }
          }

          harbour = this.fixHarbour(harbour);

          images = this.setHarbourImages(harbour, harbourPhotos);

          const row = this.buildRow(harbour, arrivalTime, departureTime, departureDate, day, images);
          itin_rows.push(row);
        }
      }
    }
    return itin_rows;
  }

  private buildRow(harbour, arrivalTime, departureTime, departureDate, day, images) {
    const row: Partial<OTOItinerary> = {};
    row.ArrivalHour = this.formatTime(arrivalTime) || null;
    row.DepartureHarbour = harbour || null;
    row.DepartureDay = day + 1;
    row.DepartureDate = new Date(departureDate);
    row.DepartureDate.setDate(departureDate.getDate() + day);
    row.DepartureDate.setHours(0, 0, 0, 0);
    row.DepartureHour = this.formatTime(departureTime) || null;
    row.Id = row.DepartureHarbour ? row.DepartureHarbour.Code + row.DepartureDay : null;
    row.Images = images;
    return row;
  }

  private formatTime(hours) {
    if (hours && hours != '-') {
      return hours.substr(0, 2) + ':' + hours.substr(-3);
    } else {
      return null;
    }
  }

  private setHarbourImages(harbour, harbourPhotos) {
    const ret = [];
    const baseAddress = '//www.offertetouroperator.com/images/cruises/oto_official/porti/';
    const placeholder = '//www.offertetouroperator.com/images/cruises/oto_official/porti/placeholder-harbour.jpg';
    const harbourCode = harbour.Code;
    harbourPhotos.forEach((photo) => {
      if (photo.indexOf(harbourCode) >= 0) {
        ret.push(baseAddress + photo);
      }
    });
    if (ret.length === 0) {
      ret.push(placeholder);
    }
    return ret;
  }

  private fixHarbour(harbour) {
    if (harbour.Name.indexOf('/') >= 0) {
      harbour.Name = harbour.Name.split('/').join(' / ');
    }
    harbour.Country = '';
    if (harbour.Name.indexOf('(') >= 0 && harbour.Name.indexOf(')') >= 0) {
      harbour.Country = harbour.Name.split('(')[1].split(')')[0];
      harbour.Name = harbour.Name.split('(')[0];
    }
    return harbour;
  }
}
